import React, { useState, useEffect } from 'react';
import Dropdown from './util/Dropdown'

function Info(props) {
    const [showSearchArea, setShowSearchArea] = useState(false);
    useEffect(() => {

    }, []);

    return (
        <div className="Info" style={{ paddingBottom: "5px" }}>
            {/*Object.keys(props.data).length > 0 && 
                <>
                    <div>
                        <div style={{ fontSize: "24px", fontWeight: "600" }}>
                        {props.data.info.title}
                        </div>
                    </div>
                    <div style={{ display: "grid", columnGap: "10px", gridTemplateColumns: "10% 40% 40% 10%" }}>
                        <div>&nbsp;</div>
                        <div style={{ textAlign:"right" }}>
                        {props.data.info.contact.name} :
                        </div>
                        <div style={{ textAlign: "left" }}>
                        {props.data.info.contact.email}
                        </div>
                        <div>&nbsp;</div>
                    </div>
                </>

            */}
            <div style={{ display: "flex", justifyContent: "space-between", columnGap: "40px", fontSize: "17px"}}>
                <div style={{ display: "flex", justifyContent: "start", columnGap: "40px", fontSize: "17px", paddingTop: "14px"}}>
                    <div>
                        <a href="/" style={{ textDecoration: "none", color: "#606f7b", cursor: "pointer", fontWeight:"500"}} >Superinvestors</a>
                    </div>
                    <div>
                        <a style={{ textDecoration: "none", color: "#606f7b", cursor: "pointer", fontWeight: "500"}} href="/Holdings" ><div className="FixedBannerMember">Holding Insights</div></a>
                    </div>
                    <div>
                        <a style={{ textDecoration: "none", color: "#606f7b", cursor: "pointer", fontWeight: "500" }} href="/DataFeed" ><div className="FixedBannerMember">Data Feed</div></a>
                    </div>
                </div>
                <div style={{ paddingTop:"8px" }}> 
                    <Dropdown setShowSearchArea={setShowSearchArea}/>
                </div>
            </div>
        </div>
    );
}
export default Info;

